import $ from 'jquery';

/** Mobile menu hierarchy handling */
export default class MobileMenu {
    constructor(theme, element) {
        this.theme = theme;
        this.element = element;
        this.$element = $(element);

        this.menuStructure = JSON.parse(document.querySelector('#mobile-menu-data').textContent);
        this.$menu = this.$element.find('#mobile-menu');
        this.$submenu = this.$element.find('#mobile-submenu');

        this.$element.find('.mobile-menu-sub').off('click').on('click', (e) => this.menuClick($(e.currentTarget), this.$menu));
        this.$element.find('.mobile-menu-back').off('click').on('click', (e) => this.backClick($(e.currentTarget)));
    }

    menuClick = ($link, $menu) => {
        this.clearSubmenus($menu);
        var handle = $link.data('link');

        if (handle === 'mobile-menu-currency') {
            $('#mobile-menu-currency').removeClass('mobile-menu-hidden');
            return;
        }

        if (handle === 'mobile-menu-locale') {
            $('#mobile-menu-locale').removeClass('mobile-menu-hidden');
            return;
        }

        this.menuStructure[handle].links.forEach((link) => {
            var menu = this.menuStructure[link];
            var $li = $('<li></li>');
            var $a = $('<a class="mobile-menu-link"></a>')
                .attr('href', menu.url)
                .html(menu.title);
            $li.append($a);
            if (menu.links.length > 0) {
                var $btn = $('<a href="#" class="mobile-menu-sub mobile-menu-right mobile-menu-link custom-font"><i data-feather="chevron-right" aria-hidden="true"></i></a>')
                    .data('link', link)
                    .on('click', (e) => { this.menuClick($(e.currentTarget), this.$submenu); });
                $li.append($btn);
            }
            $menu.append($li);
        });
        $menu.find('.mobile-menu-title').text(this.menuStructure[handle].title);
        $menu.removeClass('mobile-menu-hidden');
        this.theme.loadIcons();
    };

    clearSubmenus = ($menu) => {
        $menu.find('> li:not(:first)').remove();
    };

    backClick = ($link) => {
        $link.parents('.mobile-menu').addClass('mobile-menu-hidden');
    };
}
